import {Directive} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';
import {isNaN, isNil} from 'lodash';

@Directive({
  selector: '[appProductFormValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ProductFormValidator, multi: true }]
})
export class ProductFormValidator implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    if (!isNil(control.value) && !isNil(control.get('specifikacija')) && !isNil(control.get('item')) && !isNil(control.get('quantity'))) {
      if (isNil(control.value.specifikacija) && isNil(control.value.item)) {
        control.get('specifikacija').setErrors({ required: true });
        control.get('item').setErrors({ required: true });
      } else {
        control.get('specifikacija').setErrors(null);
        control.get('item').setErrors(null);
      }
      if (isNaN(control.value.quantity) || control.value.quantity <= 0) {
        control.get('quantity').setErrors({ required: true });
      } else {
        control.get('quantity').setErrors(null);
      }
    }
    return null;
  }
}
